/* MAC Industries – laser cutting page (sections/mac-laser-service.liquid). Prefix: mls-.
   Plays a short nested-parts cut once when the hero sheet scrolls into view (holes first, outline last, like real CAM).
   Reduced motion: nothing animates; the finished sheet in the markup stays as a still. */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var SVGNS = 'http://www.w3.org/2000/svg';

  function initReveal(root) {
    var els = root.querySelectorAll('.mls-specs, .mls-materials, .mls-how');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.25 });
    els.forEach(function (e) { io.observe(e); });
  }

  function Cutter(root) {
    this.root = root;
    this.svg = root.querySelector('.mls-sheet');
    if (!this.svg) return;
    this.parts = [].slice.call(this.svg.querySelectorAll('.mls-part'));
    this.head = this.svg.querySelector('.mls-nozzle');
    this.gantry = this.svg.querySelector('.mls-gantry');
    this.rapid = this.svg.querySelector('.mls-rapid');
    this.sparksG = this.svg.querySelector('.mls-sparks');
    this.ro = root.querySelector('.mls-readout');
    this.roState = root.querySelector('.mls-ro-state');
    this.roPart = root.querySelector('.mls-ro-part');
    this.roPct = root.querySelector('.mls-ro-pct');
    this.roBar = root.querySelector('.mls-ro-bar i');
    this.replay = root.querySelector('.mls-replay');
    this.doneText = this.roState ? this.roState.textContent : 'Done';
    this.build();
  }
  Cutter.prototype.build = function () {
    var self = this, t = 0, CUT = 820, RAPID = 2600, PIERCE = 0.16, prev = { x: 360, y: -12 };
    this.steps = []; this.cuts = [];
    this.parts.forEach(function (g, pi) {
      [].slice.call(g.querySelectorAll('.mls-cut')).forEach(function (p) {
        var L = p.getTotalLength(), s = p.getPointAtLength(0);
        var d = Math.hypot(s.x - prev.x, s.y - prev.y);
        var st = { el: p, part: pi, L: L, from: prev, to: { x: s.x, y: s.y } };
        st.t0 = t; t += d / RAPID;           // rapid move, beam off
        st.t1 = t; t += PIERCE;              // pierce
        st.t2 = t; t += L / CUT;             // cut
        st.t3 = t;
        st.outer = p.classList.contains('mls-cut--outer');
        self.steps.push(st); self.cuts.push(p);
        var e = p.getPointAtLength(L); prev = { x: e.x, y: e.y };
      });
    });
    this.total = t + 0.4;
    this.sparks = [];
    for (var i = 0; i < 26; i++) {
      var c = document.createElementNS(SVGNS, 'circle'); c.setAttribute('r', '1.6'); c.style.opacity = 0;
      this.sparksG.appendChild(c); this.sparks.push({ el: c, life: 0 });
    }
  };
  Cutter.prototype.reset = function () {
    this.steps.forEach(function (s) {
      s.el.style.strokeDasharray = s.L + ' ' + (s.L + 2); s.el.style.strokeDashoffset = s.L + 1;
      s.el.classList.remove('is-hot', 'is-cooling'); s.state = 0;
    });
    this.parts.forEach(function (g) { g.classList.remove('is-free'); });
    this.ro.classList.remove('is-done'); this.ro.classList.add('is-idle');
    if (this.roState) this.roState.textContent = 'Ready to cut';
    this.setRO(0, this.parts.length ? 1 : 0);
    if (this.replay) this.replay.hidden = true;
    this.root.classList.add('mls--run');
  };
  Cutter.prototype.setRO = function (pct, partIdx) {
    var n = this.parts.length, name = this.parts[partIdx - 1] ? this.parts[partIdx - 1].getAttribute('data-name') : '';
    if (this.roPart) this.roPart.textContent = name + ' · part ' + partIdx + ' / ' + n;
    if (this.roPct) this.roPct.textContent = Math.round(pct * 100) + '%';
    if (this.roBar) this.roBar.style.transform = 'scaleX(' + pct.toFixed(3) + ')';
  };
  Cutter.prototype.moveHead = function (x, y, on) {
    this.head.setAttribute('transform', 'translate(' + x.toFixed(1) + ' ' + y.toFixed(1) + ')');
    this.gantry.setAttribute('transform', 'translate(0 ' + y.toFixed(1) + ')');
    this.head.classList.toggle('is-off', !on);
  };
  Cutter.prototype.spark = function (x, y, n, spd) {
    for (var k = 0; k < n; k++) {
      var s = null;
      for (var i = 0; i < this.sparks.length; i++) if (this.sparks[i].life <= 0) { s = this.sparks[i]; break; }
      if (!s) return;
      var a = Math.random() * Math.PI * 2, v = (0.4 + Math.random()) * spd;
      s.x = x; s.y = y; s.vx = Math.cos(a) * v; s.vy = Math.sin(a) * v; s.life = s.max = 0.18 + Math.random() * 0.3;
    }
  };
  Cutter.prototype.tickSparks = function (dt) {
    this.sparks.forEach(function (s) {
      if (s.life <= 0) { s.el.style.opacity = 0; return; }
      s.life -= dt; s.x += s.vx * dt; s.y += s.vy * dt; s.vx *= 0.94; s.vy *= 0.94;
      s.el.setAttribute('cx', s.x.toFixed(1)); s.el.setAttribute('cy', s.y.toFixed(1));
      s.el.style.opacity = Math.max(0, s.life / s.max).toFixed(2);
    });
  };
  Cutter.prototype.play = function () {
    var self = this;
    if (this.raf) cancelAnimationFrame(this.raf);
    this.reset();
    this.ro.classList.remove('is-idle');
    if (this.roState) this.roState.textContent = 'Now cutting';
    var start = null, last = null;
    function frame(now) {
      if (start === null) { start = now; last = now; }
      var t = (now - start) / 1000, dt = Math.min(0.05, (now - last) / 1000); last = now;
      var cur = null;
      for (var i = 0; i < self.steps.length; i++) {
        var s = self.steps[i];
        if (t >= s.t3) {
          if (s.state < 3) {
            s.el.style.strokeDashoffset = 0; s.el.classList.remove('is-hot'); s.el.classList.add('is-cooling'); s.state = 3;
            if (s.outer) self.parts[s.part].classList.add('is-free');
          }
        } else if (t >= s.t0) { cur = s; break; }
      }
      if (cur) {
        var x, y, on = false;
        if (t < cur.t1) {                                  // rapid
          var k = (t - cur.t0) / Math.max(1e-3, cur.t1 - cur.t0);
          x = cur.from.x + (cur.to.x - cur.from.x) * k; y = cur.from.y + (cur.to.y - cur.from.y) * k;
          self.rapid.setAttribute('d', 'M' + cur.from.x + ' ' + cur.from.y + 'L' + x.toFixed(1) + ' ' + y.toFixed(1));
        } else if (t < cur.t2) {                           // pierce
          x = cur.to.x; y = cur.to.y; on = true;
          if (cur.state < 1) { cur.state = 1; self.rapid.setAttribute('d', ''); self.spark(x, y, 12, 90); cur.el.classList.add('is-hot'); }
        } else {                                           // cut
          var len = cur.L * (t - cur.t2) / (cur.t3 - cur.t2), p = cur.el.getPointAtLength(len);
          x = p.x; y = p.y; on = true; cur.state = 2;
          cur.el.style.strokeDashoffset = (cur.L - len).toFixed(1);
          if (Math.random() < 0.7) self.spark(x, y, 1, 60);
        }
        self.moveHead(x, y, on);
        self.setRO(Math.min(1, t / self.total), cur.part + 1);
      }
      self.tickSparks(dt);
      if (t < self.total) { self.raf = requestAnimationFrame(frame); }
      else { self.finish(); }
    }
    this.raf = requestAnimationFrame(frame);
  };
  Cutter.prototype.finish = function () {
    this.raf = null;
    this.steps.forEach(function (s) { s.el.style.strokeDashoffset = 0; s.el.classList.remove('is-hot'); });
    this.parts.forEach(function (g) { g.classList.add('is-free'); });
    this.root.classList.remove('mls--run');
    this.rapid.setAttribute('d', '');
    this.ro.classList.add('is-done');
    if (this.roState) this.roState.textContent = this.doneText;
    if (this.roPart) this.roPart.textContent = this.parts.length + ' parts';
    if (this.roPct) this.roPct.textContent = '100%';
    if (this.roBar) this.roBar.style.transform = 'scaleX(1)';
    if (this.replay) this.replay.hidden = false;
  };

  function init(root) {
    if (root.__mls) return; root.__mls = true;
    root.classList.add('mls--js');
    initReveal(root);
    if (RM && RM.matches) { root.classList.add('mls--static'); return; }   // still image, no animation
    var cutter = new Cutter(root);
    if (!cutter.svg || !cutter.steps || !cutter.steps.length) return;
    cutter.reset();
    var stage = root.querySelector('.mls-sheet-wrap');
    var played = false;
    var go = function () { if (!played) { played = true; cutter.play(); } };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); setTimeout(go, 350); } }, { threshold: 0.4 });
      io.observe(stage);
    } else { go(); }
    if (cutter.replay) cutter.replay.addEventListener('click', function () { cutter.play(); });
    if (RM && RM.addEventListener) RM.addEventListener('change', function (e) { if (e.matches) { if (cutter.raf) cancelAnimationFrame(cutter.raf); cutter.finish(); if (cutter.replay) cutter.replay.hidden = true; root.classList.add('mls--static'); } });
  }
  function boot() { document.querySelectorAll('[data-mls]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
